// extracted by mini-css-extract-plugin
export default {"root":"pageErrorFallback_root__yLvlg","content":"pageErrorFallback_content__jxg3f","buttons":"pageErrorFallback_buttons__vUx9d"};